/**
 * @generated SignedSource<<afd5cf9838b214684eeaca7146b1c0f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCard_user$data = {
  readonly displayName: string;
  readonly resourcePath: string;
  readonly followerPrivacy: boolean | null;
  readonly viewerCanFollow: boolean;
  readonly avatar: {
    readonly transformedSrc: string;
  } | null;
  readonly city: {
    readonly name: string;
    readonly province: {
      readonly shortName: string;
    } | null;
  } | null;
  readonly followers: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly following: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"UserFollowButton_user">;
  readonly " $fragmentType": "UserCard_user";
};
export type UserCard_user$key = {
  readonly " $data"?: UserCard_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCard_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCard_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserFollowButton_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourcePath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "followerPrivacy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanFollow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "maxHeight",
              "value": 160
            },
            {
              "kind": "Literal",
              "name": "maxWidth",
              "value": 160
            }
          ],
          "kind": "ScalarField",
          "name": "transformedSrc",
          "storageKey": "transformedSrc(maxHeight:160,maxWidth:160)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Province",
          "kind": "LinkedField",
          "name": "province",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "followers",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "followers(first:1)"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "following",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "following(first:1)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "c041eefcd4c78dbbb8f4b0a84089113d";

export default node;
